// Staff name → initials, with honorific stripping. Lifted out of
// the per-page inline definitions so every surface (Lista row,
// agenda timeline, home agenda, cita detail panel) reads from one
// source of truth.
//
// Honorific rule: drop a leading honorific ("Dr.", "Dra.", "Lic.",
// "Mtra.", "Mtro.", "Prof.", "Ing.") so that "Dr. Joaquín Voss"
// renders as "JV" rather than the wrong "DJ". Same regex the home
// greeting uses for the title prefix — see src/app/home/page.tsx.
//
// Returns "—" for empty / undefined inputs so consumers don't have
// to guard.

const HONORIFIC_PREFIX_RE = /^(dr\.?|dra\.?|lic\.?|mtra\.?|mtro\.?|prof\.?|ing\.?)\s+/i;

export function staffInitials(name: string | null | undefined): string {
  if (!name) return '—';
  const stripped = name.replace(HONORIFIC_PREFIX_RE, '');
  const initials = stripped
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
  return initials || '—';
}

/** The first name a staff chip shows: honorific dropped, first word kept
 *  ("Dra. Jessica" → "Jessica", "Dr. Joaquín Voss" → "Joaquín"). Falls
 *  back to the whole trimmed name when only an honorific is there, and to
 *  "" for an empty one. */
export function staffFirstName(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  const first = trimmed.replace(HONORIFIC_PREFIX_RE, '').split(/\s+/).filter(Boolean)[0];
  return first || trimmed;
}
